import React, { useState, useEffect, useRef } from 'react'; 
import { db } from '../config/firebaseConfig';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ReactDOM from 'react-dom';

// findDOMNode polyfill
const findDOMNodePolyfill = (component) => {
  return ReactDOM.findDOMNode(component);
};

// React-Quill için wrapper bileşen
const QuillWrapper = ({ value, onChange, modules }) => {
  const quillRef = useRef(null);

  useEffect(() => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      editor.root.dataset.placeholder = 'Blog içeriğini buraya yazın...';
    }
  }, []);

  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      value={value}
      onChange={onChange}
      modules={modules}
      placeholder="Blog içeriğini buraya yazın..."
    />
  );
};

const BlogDuzenle = () => {
  const [bloglar, setBloglar] = useState([]);
  const [seciliBlog, setSeciliBlog] = useState(null);
  const [baslik, setBaslik] = useState('');
  const [aciklama, setAciklama] = useState('');
  const [icerik, setIcerik] = useState('');
  const [kategori, setKategori] = useState('');
  const [tarih, setTarih] = useState('');
  const [gorsel, setGorsel] = useState(null);
  const [gorselUrl, setGorselUrl] = useState('');
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  // React Quill toolbar ayarları
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link', 'image'],
      ['clean'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'font': [] }],
      [{ 'align': [] }],
    ],
  };

  // Blog yazılarını Firestore’dan çekme
  useEffect(() => {
    const fetchBloglar = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'blogs'));
        const blogListesi = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setBloglar(blogListesi);
      } catch (error) {
        setHata('Bloglar yüklenirken bir hata oluştu: ' + error.message);
      }
    };

    fetchBloglar();
  }, []);

  // Seçilen blogu düzenleme alanına yükleme
  const handleBlogSec = (blog) => {
    setSeciliBlog(blog);
    setBaslik(blog.title);
    setAciklama(blog.description);
    setIcerik(blog.content);
    setKategori(blog.category);

    const date = new Date(blog.date);
    if (!date.getTime()) {
      setTarih(''); // Handle invalid date by setting an empty string
    } else {
      setTarih(date.toISOString().slice(0, 16)); // Format the valid date
    }

    setGorselUrl(blog.image);
  };

  // Imgur’a yeni görsel yükleme
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    setYukleniyor(true);
    try {
      const response = await axios.post('https://api.imgur.com/3/image', formData, {
        headers: {
          Authorization: 'Client-ID ff4220c8ae1adff', // Imgur Client ID ekleyin
        },
      });
      setGorselUrl(response.data.data.link);
      setGorsel(file);
      setBasari('Görsel başarıyla yüklendi!');
      setHata('');
    } catch (error) {
      setHata('Görsel yüklenirken bir hata oluştu: ' + error.message);
      setBasari('');
    } finally {
      setYukleniyor(false);
    }
  };

  // Blogu güncelleme
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!seciliBlog) {
      setHata('Lütfen düzenlemek için bir blog seçin.');
      return;
    }
    if (!baslik || !aciklama || !icerik || !kategori || !tarih || !gorselUrl) {
      setHata('Lütfen tüm alanları doldurun.');
      return;
    }

    try {
      const blogRef = doc(db, 'blogs', seciliBlog.id);
      await updateDoc(blogRef, {
        title: baslik,
        description: aciklama,
        content: icerik,
        category: kategori,
        date: new Date(tarih).toISOString(),
        image: gorselUrl,
        updatedAt: new Date().toISOString(),
      });
      setBasari('Blog başarıyla güncellendi!');
      setHata('');
      // Blog listesini güncelle
      setBloglar(bloglar.map(b => (b.id === seciliBlog.id ? { ...b, title: baslik, description: aciklama, content: icerik, category: kategori, date: new Date(tarih).toISOString(), image: gorselUrl } : b)));
    } catch (error) {
      setHata('Blog güncellenirken bir hata oluştu: ' + error.message);
      setBasari('');
    }
  };

  return (
    <div className="container-fluid">
      <h1 className="h3 mb-4 text-gray-800">Blog Düzenle</h1>
      <div className="row">
        {/* Blog Listesi */}
        <div className="col-lg-4">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Blog Yazıları</h6>
            </div>
            <div className="card-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {bloglar.length === 0 ? (
                <p>Henüz blog yazısı yok.</p>
              ) : (
                <ul className="list-group">
                  {bloglar.map(blog => (
                    <li
                      key={blog.id}
                      className={`list-group-item ${seciliBlog?.id === blog.id ? 'active' : ''}`}
                      onClick={() => handleBlogSec(blog)}
                      style={{ cursor: 'pointer' }}
                    >
                      {blog.title}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>

        {/* Blog Düzenleme Formu */}
        <div className="col-lg-8">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Blog Yazısını Düzenle</h6>
            </div>
            <div className="card-body">
              {hata && <div className="alert alert-danger">{hata}</div>}
              {basari && <div className="alert alert-success">{basari}</div>}
              {!seciliBlog ? (
                <p>Lütfen soldan bir blog yazısı seçin.</p>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="baslik">Başlık</label>
                    <input
                      type="text"
                      className="form-control"
                      id="baslik"
                      value={baslik}
                      onChange={(e) => setBaslik(e.target.value)}
                      placeholder="Blog başlığını girin"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="aciklama">Açıklama</label>
                    <textarea
                      className="form-control"
                      id="aciklama"
                      value={aciklama}
                      onChange={(e) => setAciklama(e.target.value)}
                      placeholder="Blog açıklamasını girin"
                      rows="3"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="icerik">İçerik</label>
                    <QuillWrapper
                      value={icerik}
                      onChange={setIcerik}
                      modules={modules}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="kategori">Kategori</label>
                    <input
                      type="text"
                      className="form-control"
                      id="kategori"
                      value={kategori}
                      onChange={(e) => setKategori(e.target.value)}
                      placeholder="Kategori girin"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="tarih">Tarih</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="tarih"
                      value={tarih}
                      onChange={(e) => setTarih(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="gorsel">Görsel Yükle (Imgur)</label>
                    <input
                      type="file"
                      className="form-control-file"
                      id="gorsel"
                      accept="image/*"
                      onChange={handleImageUpload}
                    />
                    {yukleniyor && <p>Görsel yükleniyor...</p>}
                    {gorselUrl && (
                      <div className="mt-2">
                        <img src={gorselUrl} alt="Yüklenen görsel" style={{ maxWidth: '200px' }} />
                      </div>
                    )}
                  </div>
                  <button type="submit" className="btn btn-primary" disabled={yukleniyor}>
                    Blogu Güncelle
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDuzenle;
